module.exports = __webpack_public_path__ + "img/nursery3.82d17aac.jpg";